import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Preloader from './components/Preloader';
import { lazy, Suspense } from 'react';
import usePageTracking from './hooks/usePageTracking';

const Home = lazy(() => import('./pages/Home'));
const Packages = lazy(() => import('./pages/Packages'));
const RoomsPage = lazy(() => import('./pages/RoomsPage'));
const ActivitiesPage = lazy(() => import('./pages/ActivitiesPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const FAQPage = lazy(() => import('./pages/FAQPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const BookNowPage = lazy(() => import('./pages/BookNowPage'));
const SelectRoomPage = lazy(() => import('./pages/SelectRoomPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const ActivityCheckoutPage = lazy(() => import('./pages/ActivityCheckoutPage'));
const PackageDetailsPage = lazy(() => import('./pages/PackageDetailsPage'));
const RoomDetailsPage = lazy(() => import('./pages/RoomDetailsPage'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const BlogPage = lazy(() => import('./pages/blog/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/blog/BlogPostPage'));
const StorePage = lazy(() => import('./pages/StorePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

/** Fires a GA4 page_view event on every route change. */
function PageTracker() {
  usePageTracking();
  return null;
}

export default function App() {
  return (
    <>
      <Preloader />
      <BrowserRouter>
      <PageTracker />
      <Suspense fallback={<div className="flex h-screen items-center justify-center bg-sand"><div className="w-12 h-12 border-4 border-ocean border-t-transparent rounded-full animate-spin"></div></div>}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="packages" element={<Packages />} />
            <Route path="packages/:slug" element={<PackageDetailsPage />} />
            <Route path="rooms" element={<RoomsPage />} />
            <Route path="rooms/:slug" element={<RoomDetailsPage />} />
            <Route path="activities" element={<ActivitiesPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogPostPage />} />
            <Route path="store" element={<StorePage />} />
            <Route path="faq" element={<FAQPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="book-now" element={<BookNowPage />} />
            <Route path="book-now/select-room" element={<SelectRoomPage />} />
            <Route path="book-now/checkout" element={<CheckoutPage />} />
            <Route path="checkout/activity/:slug" element={<ActivityCheckoutPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
    </>
  );
}
